import script from "./LinkUs.vue?vue&type=script&lang=ts&setup=true"
export * from "./LinkUs.vue?vue&type=script&lang=ts&setup=true"

import "./LinkUs.vue?vue&type=style&index=0&id=668c0eae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-668c0eae"]])

export default __exports__